import React, { useState } from "react";
import { Button, Popover, Tooltip, Box } from "@mui/material";
import { Case } from "generated/graphql";
import { CaseInfoMatrix } from "routes/lenses/lens/case/CaseInfo";
import { KeyboardArrowDown } from "@mui/icons-material";
import CopyToClipboard from "./CopyToClipboard";
import { useCaseInfoDisplayGroups } from "routes/lenses/lens/case/useCaseInfoDisplayGroups";
import { useAppSelector } from "redux/hooks";
import { selectCaseCalcs } from "redux/slices/case";

export interface CaseInfoHeaderProps {
  mycase: Case;
}

const CaseInfoHeader = (props: CaseInfoHeaderProps) => {
  const { mycase } = props;
  const calcs = useAppSelector(selectCaseCalcs);
  const [caseInfoAnchorEl, setCaseInfoAnchorEl] = useState<HTMLElement | undefined>();
  const caseInfoDisplayGroups = useCaseInfoDisplayGroups(mycase, calcs);
  const showCaseInfo = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    const t = event.currentTarget;
    setCaseInfoAnchorEl(t);
  };

  return (
    <>
      <Popover
        open={Boolean(caseInfoAnchorEl)}
        anchorEl={caseInfoAnchorEl}
        onClose={() => setCaseInfoAnchorEl(undefined)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        <CaseInfoMatrix mycase={mycase} caseDisplayGroupsWithPropertyValues={caseInfoDisplayGroups} />
      </Popover>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Tooltip title="Click for Claimant information" arrow>
          <Button
            color="default"
            onClick={showCaseInfo}
            endIcon={<KeyboardArrowDown />}
            data-pendo="case-details-dropdown">
            {mycase.info?.clientCaseId}
          </Button>
        </Tooltip>
        <CopyToClipboard text={mycase.info?.clientCaseId} />
      </Box>
    </>
  );
};

export default CaseInfoHeader;
